import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { SERVICES } from "../data/content";

const Services = () => {
  return (
    <div data-testid="services-page">
      <PageHeader
        eyebrow="Our Services"
        title={<>Comprehensive management <em className="text-brand-green font-serif italic">solutions.</em></>}
        subtitle="We specialize in providing comprehensive management solutions and services to businesses of all sizes. Our services are designed to streamline your operations, optimize efficiency, and drive sustainable growth."
      />

      {/* Services Grid */}
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="space-y-20">
            {SERVICES.map((s, i) => (
              <div key={s.slug} data-testid={`service-${s.slug}`} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <div className="lg:col-span-6">
                  <div className="relative aspect-[4/3] rounded-sm overflow-hidden group">
                    <img src={s.img} alt={s.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <div className="absolute top-4 left-4 bg-brand-gold text-brand-ink text-xs font-bold tracking-[0.2em] uppercase px-3 py-1.5">
                      0{i + 1} / {SERVICES.length}
                    </div>
                  </div>
                </div>
                <div className="lg:col-span-6">
                  <div className="text-xs font-bold tracking-[0.25em] uppercase text-brand-gold mb-4">Capability 0{i + 1}</div>
                  <h3 className="font-serif text-3xl md:text-5xl text-brand-ink tracking-tight leading-[1.05]">{s.title}</h3>
                  <p className="mt-6 text-brand-slate leading-relaxed text-lg">{s.desc}</p>
                  <Link to="/contact" data-testid={`service-cta-${s.slug}`} className="inline-flex items-center gap-2 mt-8 text-brand-green font-medium hover:gap-3 transition-all">
                    Discuss this engagement <ArrowUpRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-24 bg-brand-green-50/50">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <h2 className="font-serif text-4xl md:text-5xl text-brand-ink tracking-tight leading-tight">Not sure where to start?</h2>
          <p className="mt-5 text-brand-slate text-lg max-w-2xl mx-auto">Take our 8-12 minute Enterprise Health Assessment to surface your highest-leverage opportunities — across 10 critical business dimensions.</p>
          <Link to="/assessment" data-testid="services-assessment-cta" className="inline-flex items-center gap-2 mt-10 bg-brand-green text-white px-7 py-4 rounded-sm font-medium hover:bg-brand-green-light transition-all">
            Start Enterprise Assessment <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
